/**
 * Action types for the two discount-service slices.
 *
 * Kept in a module with **no imports** so the reducers can be unit-tested. The action modules
 * that own these thunks import `src/services/newCoreApi.js` → `jsonApi.js` → `src/api.js`, and
 * `src/api.js` imports the app entry (`./index.js`) to reach the Redux store — so a reducer that
 * took its constants from the action module would drag the entire component tree (and its SCSS)
 * into any test that imported it.
 *
 * The rest of the app declares action types inside its action modules; these two are separated
 * only because their thunks reach the network layer.
 */

export const REQUEST_MERCHANT = 'REQUEST_MERCHANT';
export const RECEIVE_MERCHANT = 'RECEIVE_MERCHANT';
export const RECEIVE_MERCHANT_ERROR = 'RECEIVE_MERCHANT_ERROR';
export const RESET_MERCHANT = 'RESET_MERCHANT';

export const REQUEST_REF_MAPS = 'REQUEST_REF_MAPS';
export const RECEIVE_REF_MAPS = 'RECEIVE_REF_MAPS';
export const RECEIVE_REF_MAPS_ERROR = 'RECEIVE_REF_MAPS_ERROR';
export const RESET_REF_MAPS = 'RESET_REF_MAPS';

export const REQUEST_DISCOUNT_ROLLOUT = 'REQUEST_DISCOUNT_ROLLOUT';
export const RECEIVE_DISCOUNT_ROLLOUT = 'RECEIVE_DISCOUNT_ROLLOUT';
export const RESET_DISCOUNT_ROLLOUT = 'RESET_DISCOUNT_ROLLOUT';
